import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import { remplirChampsCertificat } from '@/utils/certificat-champs'
import $ from 'jquery'

export default {
    name: 'manage-certificat-form',
    components: {
        VueEditor
    },
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_patient: {
            type: Object,
            default: () => ({})
        },
        info_user: Object,
        group_id: Number,
        form_toggler: Number,
        selected_content: {
            type: Object,
            default: () => ({})
        },
        data_to_be_deleted: {
            type: Object,
            default: () => ({})
        },
        slug: String,
        c_slug: String,
        liste_champs: Array,
        section_name: String,
        is_edit: {
            type: Number,
            default: () => (0)
        },
        del_toggler: {
            type: Number,
            default: () => (0)
        },
    },

    data() {
        return {
            // Même barre d'outils que l'examen clinique (04/10/2026).
            customToolbar: [
                ...vueEditorToolbar,
                ['blockquote', 'code-block'],
                [{ script: 'sub' }, { script: 'super' }],
                ['link', 'clean']
            ],
            // Dictée vocale locale, comme l'examen clinique (aucun audio transmis).
            is_listening: false,
            recognition: null,
            transcript: '',
            recognition_err_msg: '',
            active_dictation_index: null,
            dictee_tentative: 0,
            save_loading: false,
            is_loading: false,
            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,
            favori_a_enregistrer: false,
            nom_favori: '',
            favoris_certificat: [],
            favori_erreur: '',

            section_data: {
                v_model: []
            },
            selected_champ: [],
            o_occurence: [],
            filtered_occurence: [],

            l_champs: []
        }
    },

    watch : {
        form_toggler() {
            if (this.slug === 'certificat_medical') this.chargerFavoris()
            if (this.is_edit == 0) {
                this.initFields()
            } else {
                this.setFormEdition()
            }
        },

        del_toggler() {
            this.openDelModal()
        }
    },

    computed: {
        
    },

    mounted() {

    },

    methods: {
        cleFavoris() {
            const id = Number(this.user_id)
            return Number.isSafeInteger(id) && id > 0 ? 'clinicaa-certificats-favoris-v1-' + id : null
        },

        chargerFavoris() {
            const cle = this.cleFavoris()
            if (!cle) { this.favoris_certificat = []; return }
            try {
                const valeur = JSON.parse(localStorage.getItem(cle) || '[]')
                this.favoris_certificat = Array.isArray(valeur) ? valeur.filter(item => item && item.nom && item.contenu).slice(0, 30) : []
            } catch (error) {
                this.favoris_certificat = []
            }
        },

        appliquerFavori(favori) {
            if (!favori || !this.section_data.v_model.length) return
            const patient = this.info_patient || {}
            let contenu = String(favori.contenu || '')
            ;[['[NOM_PATIENT]', patient.nom_patient], ['[DATE_NAISSANCE_PATIENT]', patient.date_naissance],
                ['[DOSSIER_PATIENT]', patient.num_dossier], ['[TELEPHONE_PATIENT]', patient.telephone]]
                .forEach(([cle, valeur]) => { contenu = contenu.split(cle).join(String(valeur || '')) })
            this.section_data.v_model[0].value = contenu
        },

        memoriserFavori(contenu) {
            const nom = this.nom_favori.trim()
            if (!nom) return
            const cle = this.cleFavoris()
            if (!cle) { this.favori_erreur = 'Utilisateur non identifié : le favori n’a pas été conservé.'; return }
            const patient = this.info_patient || {}
            let modele = String(contenu || '')
            ;[[patient.nom_patient, '[NOM_PATIENT]'], [patient.date_naissance, '[DATE_NAISSANCE_PATIENT]'],
                [patient.num_dossier, '[DOSSIER_PATIENT]'], [patient.telephone, '[TELEPHONE_PATIENT]']]
                .forEach(([valeur, cle]) => { if (valeur && String(valeur).length > 3) modele = modele.split(String(valeur)).join(cle) })
            const favoris = this.favoris_certificat.filter(item => item.nom !== nom)
            favoris.unshift({ nom, contenu: modele })
            try {
                localStorage.setItem(cle, JSON.stringify(favoris.slice(0, 30)))
                this.favoris_certificat = favoris.slice(0, 30)
                this.favori_erreur = ''
            } catch (error) {
                this.favori_erreur = 'Certificat enregistré, mais le favori n’a pas pu être conservé sur cet appareil.'
            }
        },

        async setFormEdition() {
            this.l_champs = this.liste_champs
            
            this.section_data = {
                v_model: []
            }
            // this.is_loading = true

            await this.section_data.v_model.push(
                { 
                    value: this.selected_content.value, 
                    field_name: this.selected_content.field_name, 
                    type: this.selected_content.type 
                }
            );
            this.o_occurence.push('')
            this.selected_champ.push({selected_champ_occurences: []})
        },

        async initFields() {
            this.l_champs = []
            this.section_data = {
                v_model: []
            }
            this.is_loading = true
            let value  = ''
            let i = 0
            await this.liste_champs.forEach((c) => {
                if (c.is_active === 1) {
                    if (this.is_edit === 0) {
                        // Modèle pré-enregistré (Paramètres) : chaque champ automatique est remplacé partout.
                        value = remplirChampsCertificat(c.default_value, this.valeursChampsCertificat())

                        this.section_data.v_model.push(
                            { value: value, field_name: c.champ, type: c.type_champ }
                        );
                    } else {
                        this.section_data.v_model.push(
                            { 
                                value: this.selected_content.value, 
                                field_name: this.selected_content.field_name, 
                                type: this.selected_content.type 
                            }
                        );
                    }
                    
                    this.o_occurence.push('')
                    this.selected_champ.push({selected_champ_occurences: []})

                    this.l_champs.push(c)
                } 
                
                
                if (i == (this.liste_champs.length - 1)) {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 500);
                }
                i++
                
            });
        },

        saveData() {
            if (this.is_listening) this.stopRecording()
            this.permission_is_denied = false
            this.is_error = false

            if (this.slug === 'certificat_medical') {
                const hasText = this.section_data.v_model.some(champ =>
                    String(champ.value || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0
                )
                if (!hasText) {
                    this.errorToast('Rédigez le certificat avant de l’enregistrer.')
                    return
                }
                if (this.favori_a_enregistrer && !this.nom_favori.trim()) {
                    this.favori_erreur = 'Nommez le favori avant d’enregistrer.'
                    return
                }
            }

            const contenu_favori = this.slug === 'certificat_medical' && this.favori_a_enregistrer
                ? String((this.section_data.v_model[0] || {}).value || '') : ''

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: JSON.stringify(this.info_user),
                data_type: this.slug,
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.section_data.v_model.forEach((champ, index) => {
                form_data.append(`champs[${index}]`, JSON.stringify(champ));
            });
            
            this.save_loading = true

            store_fiche.saveCustomSectionData(form_data).then((response) => {
                if (response.success) {
                    if (contenu_favori) this.memoriserFavori(contenu_favori)
                    if (this.slug === 'certificat_medical') {
                        $('.certif-form-' + this.evolution_id + '-' + this.c_slug).modal('hide')
                    } else {
                        this.$refs.cert_section_form.click()
                    }
                    this.$emit('emitRefreshContent')
                    this.successToast(response.message)

                    this.section_data = {
                        v_model: []
                    },

                    this.selected_champ = []
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.cert_section_form.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        valeursChampsCertificat() {
            const patient = this.info_patient || {}
            const medecin = this.info_user || {}
            return {
                '[NOM_MEDECIN]': medecin.nom_medecin,
                '[NOM_PATIENT]': patient.nom_patient,
                '[DATE_NAISSANCE_PATIENT]': patient.date_naissance,
                '[AGE_CLINIQUE]': patient.age,
                '[DOSSIER_PATIENT]': patient.num_dossier,
                '[TELEPHONE_PATIENT]': patient.telephone,
                '[VILLE]': this.ville,
                '[DATE]': this.formatDateToDmY ? this.formatDateToDmY(this.current_date) : '',
                '[NOM_CLINIQUE]': this.nom_clinique,
            }
        },

        getQuill(index) {
            const editor = this.$refs['rich_editor_' + index]
            const instance = Array.isArray(editor) ? editor[0] : editor
            return instance ? instance.quill : null
        },

        escapeHtml(texte) {
            return String(texte).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        },

        // Dictée vocale locale (même règle que l'examen clinique : traitement sur l'appareil, aucun audio transmis).
        async recordSpeech(index) {
            this.recognition_err_msg = ''
            const quill = this.getQuill(index)
            if (quill) quill.focus()
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!SpeechRecognition) {
                this.recognition_err_msg = 'La dictée vocale n’est pas disponible dans ce navigateur. Vous pouvez continuer au clavier.'
                return
            }
            if (typeof SpeechRecognition.available !== 'function' || typeof SpeechRecognition.install !== 'function') {
                this.recognition_err_msg = 'La dictée locale n’est pas disponible dans ce navigateur. Aucun audio du dossier n’a été transmis.'
                return
            }
            const tentative = ++this.dictee_tentative
            const options = { langs: ['fr-FR'], processLocally: true }
            try {
                let disponibilite = await SpeechRecognition.available(options)
                if (disponibilite === 'downloadable' || disponibilite === 'downloading') {
                    this.recognition_err_msg = 'Installation du module de dictée française sur cet appareil…'
                    const installe = await SpeechRecognition.install(options)
                    disponibilite = installe ? 'available' : 'unavailable'
                }
                if (tentative !== this.dictee_tentative) return
                if (disponibilite !== 'available') {
                    this.recognition_err_msg = 'La dictée française locale est indisponible sur cet appareil. Aucun audio n’a été transmis.'
                    return
                }
            } catch (_) {
                if (tentative === this.dictee_tentative) this.recognition_err_msg = 'Impossible d’activer la dictée locale. Vérifiez les autorisations du navigateur.'
                return
            }
            this.recognition = new SpeechRecognition()
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'fr-FR'
            this.recognition.processLocally = true
            this.recognition.onend = () => {
                this.is_listening = false
                this.active_dictation_index = null
                this.transcript = ''
            }
            this.recognition.onresult = (evt) => {
                for (let i = evt.resultIndex; i < evt.results.length; ++i) {
                    this.transcript = evt.results[i][0].transcript
                    if (evt.results[i].isFinal) {
                        const text = this.transcript.trim() + ' '
                        this.transcript = ''
                        const activeQuill = this.getQuill(index)
                        if (activeQuill) {
                            const cursor = activeQuill.getSelection()
                            const position = cursor ? cursor.index : Math.max(0, activeQuill.getLength() - 1)
                            activeQuill.insertText(position, text, 'user')
                            activeQuill.setSelection(position + text.length, 0, 'silent')
                        } else {
                            this.section_data.v_model[index].value += this.escapeHtml(text)
                        }
                    }
                }
            }
            this.recognition.onerror = event => {
                const erreurs = {
                    'not-allowed': 'Accès au microphone refusé. Autorisez le microphone dans le navigateur.',
                    'audio-capture': 'Aucun microphone utilisable n’a été détecté.',
                    'language-not-supported': 'Le module local de dictée française n’est pas installé.',
                    'no-speech': 'Aucune parole détectée. Relancez la dictée lorsque vous êtes prêt.'
                }
                this.recognition_err_msg = erreurs[event.error] || 'La dictée locale s’est interrompue. Réessayez ou continuez au clavier.'
                this.is_listening = false
            }
            try {
                this.recognition.start()
                this.recognition_err_msg = ''
                this.is_listening = true
                this.active_dictation_index = index
            } catch (_) {
                this.recognition_err_msg = 'Impossible de démarrer la dictée. Vérifiez l’autorisation du microphone.'
            }
        },

        stopRecording() {
            this.dictee_tentative++
            if (this.recognition && this.is_listening) this.recognition.stop()
            this.is_listening = false
            this.active_dictation_index = null
            this.transcript = ''
        },

        backToFields() {
            this.stopRecording()
            if (this.slug === 'certificat_medical') {
                $('.certif-form-' + this.evolution_id + '-' + this.c_slug).modal('hide')
            } else {
                this.$refs.cert_section_form.click()
            }

            this.$emit("emitOpenFields")
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerSection(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            store_fiche.deleteFicheSectionContent(this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit("emitRefreshContent")

                    this.$refs['del_certif'].hide()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        openDelModal() {
            this.is_error = false
            this.$refs['del_certif'].show()
        }
    }
}
